// LitElement that is a paragraph block
import { css, html } from "lit";
import { setupCustomElement } from "../../lit-util.js";
import WarpElement from "@warp-ds/elements-core";

const NAME = "contentful-paragraph";

export class ContentfulParagraph extends WarpElement {
	declare fieldId: string;
	declare entryId: string;

	constructor() {
		super();
		this.fieldId = "";
		this.entryId = "";
	}

	static styles = [
		css`
			/** The line below is where the injected CSS goes, removing it means you get no CSS from the design system **/
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.static{position:static};
		`,
		...WarpElement.styles, // Adds the global styles
	] as unknown as never;

	render() {
		return html`<p
			data-contentful-entry-id="${this.entryId}"
			data-contentful-field-id=${this.fieldId}
			class="${this.className}"
		>
			<slot></slot>
		</p>`;
	}
}

setupCustomElement(NAME, ContentfulParagraph);
